import React from 'react';

export interface QueryFormSectionProps {
  robotName: string;
  setRobotName: (v: string) => void;
  startDate: string;
  setStartDate: (v: string) => void;
  endDate: string;
  setEndDate: (v: string) => void;
  queryTemplates: Record<string, { name: string; description: string }>;
  selectedQueryTemplate: string;
  setSelectedQueryTemplate: (v: string) => void;
  onQuery: () => void;
  loading: boolean;
  jobId: string | null;
  jobStatus: string;
  error: string;
}

const QueryFormSection: React.FC<QueryFormSectionProps> = ({
  robotName,
  setRobotName,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  queryTemplates,
  selectedQueryTemplate,
  setSelectedQueryTemplate,
  onQuery,
  loading,
  jobId,
  jobStatus,
  error,
}) => (
  <>
    <div className="plot-controls">
      <div className="control-group">
        <label>Robot Name:</label>
        <input
          type="text"
          value={robotName}
          onChange={(e) => setRobotName(e.target.value)}
          placeholder="e.g., PSDN-7"
          style={{ padding: '0.5rem' }}
        />
      </div>
      <div className="control-group">
        <label>Start Date:</label>
        <input
          type="datetime-local"
          value={startDate}
          onChange={(e) => setStartDate(e.target.value)}
          style={{ padding: '0.5rem' }}
        />
      </div>
      <div className="control-group">
        <label>End Date:</label>
        <input
          type="datetime-local"
          value={endDate}
          onChange={(e) => setEndDate(e.target.value)}
          style={{ padding: '0.5rem' }}
        />
      </div>
      <div className="control-group" style={{ width: '100%' }}>
        <label>Query Template:</label>
        {Object.keys(queryTemplates).length === 0 ? (
          <div style={{ padding: '0.5rem', color: '#666', fontSize: '0.9rem' }}>
            Loading query templates...
          </div>
        ) : (
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem', marginTop: '0.5rem' }}>
            {Object.entries(queryTemplates).map(([key, template]) => (
              <button
                key={key}
                onClick={() => setSelectedQueryTemplate(key)}
                style={{
                  padding: '0.5rem 1rem',
                  border: '1px solid #dee2e6',
                  borderRadius: '4px',
                  background: selectedQueryTemplate === key ? '#007bff' : '#ffffff',
                  color: selectedQueryTemplate === key ? '#ffffff' : '#000',
                  cursor: 'pointer',
                  fontSize: '0.9rem',
                }}
                title={template.description}
              >
                {template.description || key}
              </button>
            ))}
          </div>
        )}
      </div>
      <div className="control-group">
        <button
          onClick={onQuery}
          disabled={loading || !robotName || !startDate || !endDate}
          style={{ padding: '0.5rem 1rem', marginTop: '1rem' }}
        >
          Query Images
        </button>
      </div>
    </div>

    {loading && <div className="loading">Submitting query...</div>}
    {error && <div className="error">Error: {error}</div>}

    {jobId && (
      <div style={{ marginTop: '1rem', padding: '1rem', background: '#f8f9fa', borderRadius: '4px' }}>
        <div>
          <strong>Job ID:</strong> {jobId}
        </div>
        <div>
          <strong>Status:</strong> {jobStatus}
        </div>
        {jobStatus === 'processing' && (
          <div style={{ marginTop: '0.5rem', fontSize: '0.9rem', color: '#666' }}>
            Processing query... This may take a moment.
          </div>
        )}
      </div>
    )}
  </>
);

export default QueryFormSection;
